import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {QbTransactionDto} from "../model/QbTransactionDto";
import {DebounceFactory} from "../modules/DebounceModule";
import {QbTxnType} from "../model/QbTxnType";
import {StateService} from "@uirouter/angularjs";

class ContactListController implements IComponentController {
    private customerGuid: string;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope, private $debounce: DebounceFactory,
                private $state: StateService) {
        $dataHub.onConnected(this.reloadDebounce, this.disposeBag);
    }

    reload = () => {
        if (!this.customerGuid) return;
    };

    reloadDebounce = this.$debounce(this.reload, 1000, false);

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.reloadDebounce();
    }

    $onDestroy?() {
        this.disposeBag.finalize();
    }


}

export default angular.module('component.contactList', [])
    .component('contactList', {
        template: require('./ContactList.html'),
        controller: ContactListController,
        bindings: {
            customerGuid: '<',
        }
    }).name;
